module.exports = __webpack_public_path__ + "static/media/accessible.cdacc663.svg";